import { ADMIN_BREADCRUMB } from '../../constants/actions';
import { addContextToRoute } from '../../lib/route.utils';
import { formDataSelector } from '../../selectors/admin/forms';
import { forEach } from 'lodash';

export function setBreadcrumb(locations, params) {
    return (dispatch, getState) => {
        const linkedLocations = locations.map(loc => {
            switch (loc.type) {
                case 'form':
                    return _formBreadcrumb(loc, params, getState);
                default:
                    return _defaultBreadcrumb(loc, params);
            }
        });
        dispatch({
            type: ADMIN_BREADCRUMB.SET,
            locations: params.context
                ? linkedLocations.map(l => ({ ...l, link: addContextToRoute(l.link, params.context) }))
                : linkedLocations
        });
    };
}

const _defaultBreadcrumb = (loc, params) => {
    let bcLink = loc.link;
    forEach(params, (v, k) => {
        bcLink = bcLink.replace(`:${k}`, v);
    });
    loc.link = bcLink;
    return loc;
};

const _formBreadcrumb = (location, params, getState) => {
    const formData = formDataSelector(getState(), { model: location.model });
    return {
        label: params[`${location.model}Id`] ? formData[location.idField || 'name'] : `Add ${location.model}`,
        link: params[`${location.model}Id`]
            ? location.linkUpdate
                  .replace(`:${location.model}Id`, params[`${location.model}Id`])
                  .replace(`:${location.subContext}Id`, params[`${location.subContext}Id`])
            : location.linkCreate.replace(`:${location.subContext}Id`, params[`${location.subContext}Id`])
    };
};



// WEBPACK FOOTER //
// ./src/actions/admin/breadcrumb.js